(function($) {
    "use strict";

    if ($ === false) {
        return false;
    }

    var options = {},
        defaults = {
            model: '',
            fieldValidateUrl: false,
            formValidateUrl: false,
            showIcons: false,
            validIcon: 'circle-ok',
            errorIcon: 'circle-remove',
            warningIcon: 'circle-exclamation-mark',
            onValidateField: false,
            onFieldError: false,
            onFieldWarning: false,
            onFieldValid: false,
            onValidateForm: false,
            onFormError: false,
            onFormValid: false
        };

    $.fn.validator = function (settings, params) {
        if (typeof settings === 'string') {
            // Run a command
            return $.fn.validatorCommands[settings].call(this, params);
        }

        options = $.extend({}, defaults, settings);
        addDefaultEvents();

        this.each(function () {
            // If no model is given, take a best guess from the ID
            if (!options.model) {
                options.model = $(this).attr('id').replace('Form', '');
            }

            if ($(this).is('form')) {
                // Unbind all validator events to prevent events from being repeated
                unbindEvents(this);

                // Bind validation events
                $(this).on('change.validator', 'select, input[type="radio"], input[type="checkbox"]', function () {
                    if ((typeof $(this).data('no-validate') === 'undefined' || $(this).data('no-validate') === false) && $(this).closest('.fr-box').length === 0) {
                        validateField(this, $(this).parents('form'));
                    }
                });
                $(this).on('blur.validator', 'input:not(input[class*="dateinput"])[type!="button"][type!="submit"][type!="radio"][type!="checkbox"], textarea', function () {
                    if ((typeof $(this).data('no-validate') === 'undefined' || $(this).data('no-validate') === false) && $(this).closest('.fr-box').length === 0) {
                        validateField(this, $(this).parents('form'));
                    }
                });
                $(this).on('dp.change', 'input[class*="dateinput"]', function () {
                    if (typeof $(this).data('no-validate') === 'undefined' || $(this).data('no-validate') === false) {
                        validateField(this, $(this).parents('form'));
                    }
                });
                $(this).on('switchChange.bootstrapSwitch', '.bootstrap-switch input[type="checkbox"]', function () {
                    if (typeof $(this).data('no-validate') === 'undefined' || $(this).data('no-validate') === false) {
                        validateField(this, $(this).parents('form'));
                    }
                });
                $(this).on('submit.validator', function () {
                    if (!$(this).data('validated') || $(this).data('validated') === false) {
                        var button = $(this).find('input[type="submit"]:first, button[type="submit"]:first, a.submit:first');
                        validateForm(this, button);
                        return false;
                    } else {
                        return true;
                    }
                });

                // Allow some options to be overriden by data values on the form
                if ($(this).data('show-icons') === true) {
                    options.showIcons = true;
                }
                if (typeof $(this).data('valid-icon') === 'string') {
                    options.validIcon = $(this).data('valid-icon');
                }
                if (typeof $(this).data('error-icon') === 'string') {
                    options.errorIcon = $(this).data('error-icon');
                }
                if (typeof $(this).data('warning-icon') === 'string') {
                    options.warningIcon = $(this).data('warning-icon');
                }

                // Add validation flag to form
                $(this).data('validation', true);
            }

            return true;
        });

        return true;
    };

    $.fn.validatorCommands = {
        validate: function (settings) {
            var _defaults = {
                button: null,
                success: function (form) {},
                failure: function (form, errors) {}
            };

            var _options = $.extend({}, _defaults, settings);

            validateForm(this, _options['button'], _options['success'], _options['failure']);
        },
        fieldError: function (settings) {
            options.onFieldError.call(false, settings['field'], settings['message']);
        }
    };

    function addDefaultEvents () {
        if (options.onValidateField === false) {
            options.onValidateField = function (field) {
                if ((options.showIcons === true && $(field).data('show-icon') !== false) || (options.showIcons === false && $(field).data('show-icon') === true)) {
                    $(field).closest('.form-group,.input').find('span.glyphicon.form-control-feedback').remove();
                }
                $(field).closest('.form-group,.input').removeClass('has-error has-warning has-success has-feedback');

                if ($(field).parents('.bootstrap-switch').length >= 1) {
                    $(field).closest('.bootstrap-switch').next('.label').remove();
                    $(field).closest('.bootstrap-switch').removeClass('has-error has-warning has-success has-feedback');
                } else {
                    $(field).closest('.form-group,.input').find('.label-danger,.label-warning').remove();
                }
            };
        }

        if (options.onFieldWarning === false) {
            options.onFieldWarning = function (field, message) {
                $(field).closest('.form-group,.input').addClass('has-warning');

                if ($(field).parents('.bootstrap-switch').length >= 1) {
                    $(field).closest('.bootstrap-switch').addClass('has-warning');
                    $(field).closest('.bootstrap-switch').after('<span class="label label-warning">' + message + '</span>');
                } else {
                    if ($(field).is('input[type="checkbox"], input[type="radio"]')) {
                        $(field).closest('.form-group,.input').find('label:first').append('<span class="label label-warning">' + message + '</span>');
                    } else {
                        $(field).closest('.form-group,.input').append('<span class="label label-warning">' + message + '</span>');
                        if ((options.showIcons === true && $(field).data('show-icon') !== false) || (options.showIcons === false && $(field).data('show-icon') === true)) {
                            $(field).closest('.form-group,.input').addClass('has-feedback');
                            if ($(field).is('select')) {
                                $(field).closest('.form-group,.input').append('<span class="glyphicon glyphicon-chevron-down form-control-feedback"></span>');
                            } else if ($(field).is('radio,checkbox') === false) {
                                $(field).closest('.form-group,.input').append('<span class="glyphicon glyphicon-' +  options.warningIcon + ' form-control-feedback"></span>');
                            }
                        }
                    }
                }
            };
        }

        if (options.onFieldError === false) {
            options.onFieldError = function (field, message) {
                $(field).closest('.form-group,.input').addClass('has-error');

                if ($(field).parents('.bootstrap-switch').length >= 1) {
                    $(field).closest('.bootstrap-switch').addClass('has-error');
                    $(field).closest('.bootstrap-switch').after('<span class="label label-danger">' + message + '</span>');
                } else {
                    if ($(field).is('input[type="checkbox"], input[type="radio"]')) {
                        $(field).closest('.form-group,.input').find('label:first').append('<span class="label label-danger">' + message + '</span>');
                    } else {
                        $(field).closest('.form-group,.input').append('<span class="label label-danger">' + message + '</span>');
                        if ((options.showIcons === true && $(field).data('show-icon') !== false) || (options.showIcons === false && $(field).data('show-icon') === true)) {
                            $(field).closest('.form-group,.input').addClass('has-feedback');
                            if ($(field).is('select')) {
                                $(field).closest('.form-group,.input').append('<span class="glyphicon glyphicon-chevron-down form-control-feedback"></span>');
                            } else if ($(field).is('radio,checkbox') === false) {
                                $(field).closest('.form-group,.input').append('<span class="glyphicon glyphicon-' +  options.errorIcon + ' form-control-feedback"></span>');
                            }
                        }
                    }
                }
            };
        }

        if (options.onFieldValid === false) {
            options.onFieldValid = function (field) {
                $(field).closest('.form-group,.input').addClass('has-success');

                if ($(field).parents('.bootstrap-switch').length >= 1) {
                    $(field).closest('.bootstrap-switch').addClass('has-success');
                } else {
                    if ($(field).not('input[type="checkbox"], input[type="radio"]')) {
                        if ((options.showIcons === true && $(field).data('show-icon') !== false) || (options.showIcons === false && $(field).data('show-icon') === true)) {
                            $(field).closest('.form-group,.input').addClass('has-feedback');
                            if ($(field).is('select')) {
                                $(field).closest('.form-group,.input').append('<span class="glyphicon glyphicon-chevron-down form-control-feedback"></span>');
                            } else if ($(field).is('radio,checkbox') === false) {
                                $(field).closest('.form-group,.input').append('<span class="glyphicon glyphicon-' +  options.validIcon + ' form-control-feedback"></span>');
                            }
                        }
                    }
                }
            };
        }

        if (options.onValidateForm === false) {
            options.onValidateForm = function (form, button) {
                // Clear all fields of error/success states
                $(form).find('select, input[type="radio"], input[type="checkbox"], input[type!="button"][type!="submit"][type!="radio"][type!="checkbox"][class!="select2-search__field"][class!="datepicker"], textarea').not('input[type="radio"]:not(:checked), input[type="hidden"]').each(function () {
                    options.onValidateField.call(false, this);
                });

                $(button).removeClass('btn-success btn-primary btn-default btn-danger btn-warning btn-info');
                $(button).addClass('btn-info');
                $(button).text('Checking data. Please wait.');
                if ($(button).hasClass('btn-labeled')) {
                    $(button).prepend('<span class="btn-label"><i class="glyphicon glyphicon-clock"></i></span>');
                }
                $(button).prop('disabled', true);

                $('.nav-tabs li a').removeClass('error');
            };
        }

        if (options.onFormError === false) {
            options.onFormError = function (form, button, fields) {
                $(form).data('validated', false);

                $(button).removeClass('btn-success btn-primary btn-default btn-danger btn-warning btn-info');
                $(button).addClass('btn-danger');
                $(button).text('Please fix the errors above, then click here to try again');
                if ($(button).hasClass('btn-labeled')) {
                    $(button).prepend('<span class="btn-label"><i class="glyphicon glyphicon-circle-remove"></i></span>');
                }
                $(button).prop('disabled', false);

                for (var field in fields) {
                    if ($(field).length === 0) {
                        // Try and determine field from the ID
                        $(form).find('select, input[type="radio"], input[type="checkbox"], input[type!="button"][type!="submit"][type!="radio"][type!="checkbox"][class!="select2-search__field"][class!="datepicker"], textarea').not('input[type="radio"]:not(:checked), input[type="hidden"]').each(function () {
                            var name = $(this).attr('name');
                            var parts = name.match(/\[(.*?)\]/g);

                            var model = convertName(parts[0]);
                            var model_field = convertName(parts[1]);
                            var converted = '#' + model + model_field;

                            if (converted == field) {
                                field = $(this);
                            }
                        });
                    }

                    if (field) {
                        options.onValidateField.call(null, field);
                        options.onFieldError.call(null, field, fields[field]);
                    }
                }
            };
        }

        if (options.onFormValid === false) {
            options.onFormValid = function (form, button) {
                $(form).data('validated', true);

                $(button).removeClass('btn-success btn-primary btn-default btn-danger btn-warning btn-info');
                $(button).addClass('btn-success');
                $(button).text('All good. Continuing...');
                if ($(button).hasClass('btn-labeled')) {
                    $(button).prepend('<span class="btn-label"><i class="glyphicon glyphicon-circle-ok"></i></span>');
                }
                $(button).prop('disabled', false);

                $(form).submit();
            };
        }
    }

    function unbindEvents (form) {
        $(form).find('input[type!="button"], input[type!="submit"], select, textarea').off('change.validator').off('blur.validator');
        $(form).off('switchChange.bootstrapSwitch');
        $(form).off('submit.validator');
        return true;
    }

    function validateField (field, form) {
        var url,
            info = {},
            info_string = '';

        if (typeof options.onValidateField === 'function') {
            options.onValidateField.call(false, field);
        }

        // If no field validate URL is specified, try the default one for ABWeb CMS
        if (!options.fieldValidateUrl) {
            url = '/cms/pages/ajax_validate_field';
        } else {
            url = options.fieldValidateUrl;
        }

        // Add additional field information
        info['current_field'] = $(field).attr('name');
        if (typeof $(field).data('field') === 'string') {
            info['field'] = $(field).data('field');
        }
        if (typeof $(field).data('model') === 'string') {
            info['model'] = $(field).data('model');
        }
        if (typeof $(field).data('plugin') === 'string') {
            info['plugin'] = $(field).data('plugin');
        }
        for (var i in info) {
            info_string += '&data[' + i + ']=' + info[i];
        }

        $.ajax({
            url: url,
            method: 'POST',
            data: $('select, input[type="radio"], input[type="checkbox"], input[type!="button"][type!="submit"][type!="radio"][type!="checkbox"][class!="select2-search__field"][class!="datepicker"], textarea').serialize() + info_string,
            dataType: 'json',
            error: function (request, errno, error) {
                if (typeof options.onFieldError === 'function') {
                    options.onFieldError.call(false, field, 'Unable to validate field');
                }
            },
            success: function (data, request) {
                if (data.success) {
                    if (data.validates === true) {
                        if (typeof options.onFieldValid === 'function') {
                            options.onFieldValid.call(false, field);
                        }
                    } else {
                        if (data.warning) {
                            if (typeof options.onFieldWarning === 'function') {
                                options.onFieldWarning.call(false, field, data.warning);
                            }
                        } else {
                            if (typeof options.onFieldError === 'function') {
                                options.onFieldError.call(false, field, data.error);
                            }
                        }
                    }
                } else {
                    if (typeof options.onFieldError === 'function') {
                        options.onFieldError.call(false, field, 'Unable to validate field');
                    }
                }
            }
        });
    }

    function validateForm (form, button, success, failure) {
        var url;

        if (typeof options.onValidateForm === 'function') {
            options.onValidateForm.call(false, form, button);
        }

        // If no field validate URL is specified, try the default one for ABWeb CMS
        if (!options.formValidateUrl) {
            url = '/cms/pages/ajax_validate_form';
        } else {
            url = options.formValidateUrl;
        }

        $.ajax({
            url: url,
            method: 'POST',
            data: $('select, input[type="radio"], input[type="checkbox"], input[type!="button"][type!="submit"][type!="radio"][type!="checkbox"][class!="select2-search__field"][class!="datepicker"], textarea').serialize() + '&data[model]=' + options.model,
            dataType: 'json',
            error: function (request, errno, error) {
                if (typeof failure === 'function') {
                    failure.call(false, form, 'Unable to validate form');
                } else if (typeof options.onFormError === 'function') {
                    options.onFormError.call(false, form, button, 'Unable to validate form');
                }
            },
            success: function (data, request) {
                if (data.success) {
                    if (data.validates === true) {
                        if (typeof success === 'function') {
                            success.call(false, form);
                        } else if (typeof options.onFormValid === 'function') {
                            options.onFormValid.call(false, form, button);
                        }
                    } else {
                        if (typeof failure === 'function') {
                            failure.call(false, form, data.fields);
                        } else if (typeof options.onFormError === 'function') {
                            options.onFormError.call(false, form, button, data.fields);
                        }
                    }
                } else {
                    if (typeof failure === 'function') {
                        failure.call(false, form, 'Unable to validate form');
                    } else if (typeof options.onFormError === 'function') {
                        options.onFormError.call(false, field, button, 'Unable to validate form');
                    }
                }
            }
        });
    }

    function convertName (name) {
        var parts = name.split(/[\-|\_|\s+]/g);
        var part = '';
        var cased = '';

        for (var i = 0; i < parts.length; i++) {
            part = parts[i].replace('[', '').replace(']', '');
            cased = part.charAt(0).toUpperCase();
            parts[i] = cased + part.substr(1);
        }

        return parts.join('');
    }

    return true;
})(jQuery);
